import { useEffect, useRef, useState } from "react";
import { motion, useReducedMotion } from "motion/react";
import { ShieldAlert } from "lucide-react";
import { cn } from "@/lib/utils";
import type { Severity } from "@/types";

const severityStyle: Record<string, string> = {
  LOW: "border-success/25 bg-success-soft text-success",
  WATCH: "border-watch/25 bg-watch-soft text-watch",
  WARNING: "border-warning/25 bg-warning-soft text-warning",
  SEVERE: "border-severe/25 bg-severe-soft text-severe",
};

export function SeverityPill({ severity }: { severity: Severity | string }) {
  const reduce = useReducedMotion();
  const previous = useRef(severity);
  const [bump, setBump] = useState(false);

  useEffect(() => {
    if (previous.current === severity) return;
    previous.current = severity;
    setBump(true);
  }, [severity]);

  return (
    <motion.span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase",
        severityStyle[severity] || severityStyle["WATCH"],
      )}
      animate={reduce || !bump ? { scale: 1 } : { scale: [1, 1.12, 1] }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      onAnimationComplete={() => setBump(false)}
    >
      <ShieldAlert className="h-3 w-3" />
      {severity === "SEVERE" ? "HIGH" : severity === "LOW" ? "LOW" : "MEDIUM"}
    </motion.span>
  );
}
